<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Jogos</span>
        <h3 class="page-title">Adicionar</h3>
      </d-col>
    </d-row>

    <puzzle-page/>
  </d-container>
</template>

<script>
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import { MODEL, _LOAD_MODEL_ } from '../components/PuzzleModel';
import PuzzlePage from '../components/PuzzlePage.vue';

export default {
  name: 'puzzle-create',
  components: {
    PuzzlePage,
  },
  created() {
    Events.$emit('sidebarVisible', false);
  },
  mounted() {
    Events.$emit(_LOAD_MODEL_, cloneDeep(MODEL));
    this.$store.commit('setPuzzle', cloneDeep(MODEL));
  },
};
</script>

